import React from "react";
import {css} from "@panda/css";
import cn from "classnames";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {creditContributionDefault} from "../constants/credit_contribution_default";
import {creditPeriodDefault} from "../constants/credit_period_default";
import {calculateInstallment} from "../utils/calculate_installment";

interface IProps {
    price: number | null;
    className?: string;
    currency: Currency;
}

export const CreditEstimatedValue = (props: IProps) => {
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    if (!props.price) {
        return null;
    }
    const calculatedInstallment = calculateInstallment(props.price, creditContributionDefault, creditPeriodDefault);

    if (!calculatedInstallment) {
        return null;
    }

    return (
        <div className={cn(estimatePriceInfo, props.className)}>
            <BrandCoinIcon size="1.6" wrapperSize="1.6" />
            <Text variant="body_copy_2">
                Estymowana rata kredytu: <b>{priceFormat(calculatedInstallment, {unit: currencyUnit})}</b>
            </Text>
        </div>
    );
};

const estimatePriceInfo = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    mt: 0.5
});
import React from "react";
import {css} from "@panda/css";
import cn from "classnames";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {creditContributionDefault} from "../constants/credit_contribution_default";
import {creditPeriodDefault} from "../constants/credit_period_default";
import {calculateInstallment} from "../utils/calculate_installment";

interface IProps {
    price: number | null;
    className?: string;
    currency: Currency;
}

export const CreditEstimatedValue = (props: IProps) => {
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    if (!props.price) {
        return null;
    }
    const calculatedInstallment = calculateInstallment(props.price, creditContributionDefault, creditPeriodDefault);

    if (!calculatedInstallment) {
        return null;
    }

    return (
        <div className={cn(estimatePriceInfo, props.className)}>
            <BrandCoinIcon size="1.6" wrapperSize="1.6" />
            <Text variant="body_copy_2">
                Estymowana rata kredytu: <b>{priceFormat(calculatedInstallment, {unit: currencyUnit})}</b>
            </Text>
        </div>
    );
};

const estimatePriceInfo = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    mt: 0.5
});
